import { KEYS } from 'platejs'
import { useEditorReadOnly } from 'platejs/react'

import { Icon } from '@hap/components'

import { MarkToolbarButton } from './mark-toolbar-button'

export function FloatingToolbarButtons() {
  const readOnly = useEditorReadOnly()

  return (
    <>
      {!readOnly && (
        <>
          <MarkToolbarButton nodeType={KEYS.bold} tooltip="Bold (⌘+B)">
            <Icon name="text-b" />
          </MarkToolbarButton>

          <MarkToolbarButton nodeType={KEYS.italic} tooltip="Italic (⌘+I)">
            <Icon name="text-italic" />
          </MarkToolbarButton>

          <MarkToolbarButton nodeType={KEYS.underline} tooltip="Underline (⌘+U)">
            <Icon name="text-underline" />
          </MarkToolbarButton>

          <MarkToolbarButton
            nodeType={KEYS.strikethrough}
            tooltip="Strikethrough (⌘+⇧+M)"
          >
            <Icon name="text-strikethrough" />
          </MarkToolbarButton>
        </>
      )}
    </>
  )
}
